import React, { useState } from 'react'
import Pagination from '../Components/shared/Pagination/Pagination'

const usePagination = (defaultRows) => {//Settings.PaginationDefaultRows
    //For Files Pagination

    const [PerPage, setPerPage] = useState(defaultRows);
    const [PageNo, setPageNo] = useState(1);
    const [Counts,setCounts]=useState(0)
    const [TotalPages, setTotalPages] = useState();
    const handlePageClick = (page) => { setPageNo(page); }
    const PreviousPage = () => { if (PageNo > 1) setPageNo(PageNo - 1); }
    const NextPage = () => { if (PageNo < TotalPages) setPageNo(PageNo + 1); }
    const handleFingByCreteria = (e) => {
        setPerPage(e.target.value)
        setPageNo(1)
    }

    const handleSelectData = (data) => {
        setPerPage(data.value)
        setPageNo(1)
    }
    let paginationSection =
        <Pagination
            Counts={Counts}
            PerPage={PerPage}
            PageNo={PageNo}
            TotalPages={TotalPages}
            handlePageClick={handlePageClick}
            PreviousPage={PreviousPage}
            handleFingByCreteria={handleFingByCreteria}
            NextPage={NextPage}
            handleSelectData = {handleSelectData}
        />

    return ({ paginationSection, PerPage, PageNo, TotalPages, Counts, setCounts, handlePageClick, PreviousPage, NextPage, handleFingByCreteria, setTotalPages,handleSelectData }
    )
}

export default usePagination